// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2Row4","game-container":"game-container--swjjX","close":"close--otHK2","game-wrap":"game-wrap--kH2bq"};